/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom";
import styles from "./news.module.css";
import { NEWS_POST } from "../../GSA_CONSTANTS";

const VIRDIO_HOME_PATH = "/virdiohealth";

const scrollToSection = (history, location, sectionId) => {
  if (location.pathname !== VIRDIO_HOME_PATH) {
    history.push(VIRDIO_HOME_PATH);
    setTimeout(() => {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  } else {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
  }
};

const goToMyraIntake = () => {
  window.location.replace("https://myptmyra.com/intake/lower-back");
};

/* HEADER COMPONENT  */
const Header = () => {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const toggleMobileNav = () => {
    setIsMobileNavOpen((prevState) => !prevState);
  };

  const navigateToSection = (sectionId) => scrollToSection(history, location, sectionId);
  const goToVirdioHome = () => history.push(VIRDIO_HOME_PATH);

  const handleMeberLoginClick = () => {
    if (window.isStartedLandingFlow) {
      if (window.mayraCode) {
        window.mayraCode.setIsVisible(false);
        window.mayraCode.forceStop();
        window.mayraCode = null;
        window.startFlow = null;
        window.currentCommandsAudio = {};
      }
      sessionStorage.removeItem("voiceService_wasListening");
      sessionStorage.removeItem("voiceService_currentFlow");
    }

    if (window.doKeepVideoPlay) window.doKeepVideoPlay();
    if (window.preloadAllAudios) window.preloadAllAudios();
    if (window.videoUnlockPlay) window.videoUnlockPlay();

    window.isThisFromHomeScreen = false;

    setTimeout(() => {
      if (!window.isFlutterLoaded) {
        const loader = document.getElementById("flutter-loader");
        if (loader) {
          loader.style.display = "flex";
          const loaderText = loader.querySelector("#loader-text");
          if (loaderText) loaderText.textContent = "Loading application...";
        }
      }

      const flutterRoot = document.getElementById("OnDemandPlayingRoot");
      if (flutterRoot) flutterRoot.style.display = "block";

      const currentAssessmentRoot = document.getElementById("assesmentDiv");
      if (currentAssessmentRoot) currentAssessmentRoot.style.display = "none";

      localStorage.removeItem("loadSelf");
      localStorage.removeItem("startedSelf");

      window.doNextLocation = history;
      document.querySelector("html").classList = [];
      window.history.pushState({ loginGuard: true }, "");
      if (window._loginBackGuardHandler) {
        window.removeEventListener("popstate", window._loginBackGuardHandler);
      }
      const handlePopState = () => {
        if (typeof window.showLoginBackGuard === "function") {
          window.showLoginBackGuard();
        }
      };
      window._loginBackGuardHandler = handlePopState;
      window.addEventListener("popstate", handlePopState);

      setTimeout(() => {
        if (window.setHideElementsElm) window.setHideElementsElm(true);
      }, 2000);
    }, 100);
  };

  return (
    <header className={styles.siteHeader}>
      <div className={styles.headerInner}>
        <Link to={VIRDIO_HOME_PATH} className={styles.logo}>
          Virdio<span>Health</span>
        </Link>

        <nav className={styles.navLinks}>
          <button type="button" className={styles.navLink} onClick={() => navigateToSection("members")}>
            For Members
          </button>
          <button type="button" className={styles.navLink} onClick={() => navigateToSection("employers")}>
            For Employers/Partners
          </button>
          <button type="button" className={styles.navLink} onClick={() => navigateToSection("myra")}>
            Meet Myra
          </button>
          <button type="button" className={`${styles.navLink} ${styles.login}`} onClick={() => handleMeberLoginClick()}>
            Log In
          </button>
          <button type="button" className={styles.ctaBtn} onClick={goToMyraIntake}>
            See Myra in Action
          </button>
        </nav>

        <button type="button" className={styles.mobileMenuBtn} aria-label="Menu" aria-expanded={isMobileNavOpen} onClick={toggleMobileNav}>
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      <nav className={`${styles.mobileNav} ${isMobileNavOpen ? styles.open : ""}`}>
        <button
          type="button"
          className={styles.navLink}
          onClick={() => {
            navigateToSection("members");
            setIsMobileNavOpen(false);
          }}
        >
          For Members
        </button>
        <button
          type="button"
          className={styles.navLink}
          onClick={() => {
            navigateToSection("employers");
            setIsMobileNavOpen(false);
          }}
        >
          For Employers/Partners
        </button>
        <button
          type="button"
          className={styles.navLink}
          onClick={() => {
            navigateToSection("myra");
            setIsMobileNavOpen(false);
          }}
        >
          Meet Myra
        </button>
        <button
          type="button"
          className={`${styles.navLink} ${styles.login}`}
          onClick={() => {
            handleMeberLoginClick();
            setIsMobileNavOpen(false);
          }}
        >
          Log In
        </button>
        <button
          type="button"
          className={styles.ctaBtn}
          style={{ display: "inline-block", textAlign: "center" }}
          onClick={() => {
            setIsMobileNavOpen(false);
            goToMyraIntake();
          }}
        >
          See Myra in Action
        </button>
      </nav>
    </header>
  );
};

const NEWS_API_BASE = NEWS_POST;

const formatReleaseDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

const News = () => {
  const { slug } = useParams();
  const history = useHistory();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);
  const [detailsBySlug, setDetailsBySlug] = useState({});
  const [detailLoadingSlug, setDetailLoadingSlug] = useState(null);
  // const [printTarget, setPrintTarget] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch(NEWS_API_BASE)
      .then((res) => res.json())
      .then((body) => {
        if (cancelled) return;
        setPosts(body && body.success && Array.isArray(body.data) ? body.data : []);
        setLoading(false);
      })
      .catch(() => {
        if (cancelled) return;
        setLoadError(true);
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  // useEffect(() => {
  //   if (!printTarget) return undefined;
  //   const timer = setTimeout(() => {
  //     window.print();
  //     setPrintTarget(null);
  //   }, 50);
  //   return () => clearTimeout(timer);
  // }, [printTarget, detailsBySlug]);

  const loadDetail = (slug) => {
    if (detailsBySlug[slug] || detailLoadingSlug === slug) return Promise.resolve(detailsBySlug[slug] || null);
    setDetailLoadingSlug(slug);
    return fetch(`${NEWS_API_BASE}/${encodeURIComponent(slug)}`)
      .then((res) => res.json())
      .then((body) => {
        const detail = body && body.success ? body.data : null;
        setDetailsBySlug((prev) => ({ ...prev, [slug]: detail }));
        setDetailLoadingSlug(null);
        return detail;
      })
      .catch(() => {
        setDetailLoadingSlug(null);
        return null;
      });
  };

  useEffect(() => {
    if (!slug) return;
    if (detailsBySlug[slug] || detailLoadingSlug === slug) return;
    loadDetail(slug);
  }, [slug]);

  const toggleRead = (e, post) => {
    e.preventDefault();
    history.push(`/news/${post.slug}`);
  };

  const closeRelease = () => {
    history.push("/news");
  };

  return (
    <>
      {!slug && (
        <>
          <section className={styles.pageIntro}>
            <div className={styles.wrap} style={{ paddingLeft: 0, paddingRight: 0 }}>
              <p className={styles.eyebrow}>Company</p>
              <h1 className={styles.pageTitle}>News</h1>
              <p className={styles.subtitle}>Announcements and press releases from Virdio Health.</p>
            </div>
          </section>

          <section className={styles.releaseList}>
            <div className={styles.wrap} style={{ paddingLeft: 0, paddingRight: 0 }}>
              {loading && <p className={styles.releaseStatus}>Loading news…</p>}
              {!loading && loadError && <p className={styles.releaseStatus}>Couldn't load news right now. Please try again later.</p>}
              {!loading && !loadError && posts.length === 0 && <p className={styles.releaseStatus}>No news posted yet.</p>}

              {!loading &&
                !loadError &&
                posts.map((post) => {
                  const hasPdf = post.content_type === "pdf" && Boolean(post.pdf_url);

                  return (
                    <article key={post.id} className={styles.releaseItem}>
                      <span className={styles.releaseDate}>{formatReleaseDate(post.published_at)}</span>
                      <div className={styles.releaseBody}>
                        <a href={`/news/${post.slug}`} className={styles.releaseTitle} onClick={(e) => toggleRead(e, post)}>
                          {post.title}
                        </a>
                        <p className={styles.releaseExcerpt}>{post.excerpt}</p>

                        <div className={styles.releaseActions}>
                          <a href={`/news/${post.slug}`} className={styles.readLink} onClick={(e) => toggleRead(e, post)}>
                            Read release →
                          </a>

                          {hasPdf && (
                            <a href={post.pdf_url} download={post.pdf_file_name || undefined} target="_blank" rel="noreferrer" className={styles.downloadLink}>
                              Download PDF
                            </a>
                          )}
                        </div>
                      </div>
                    </article>
                  );
                })}
            </div>
          </section>
        </>
      )}

      {slug &&
        (() => {
          const detail = detailsBySlug[slug];
          const isDetailLoading = detailLoadingSlug === slug;
          const hasPdf = detail && detail.content_type === "pdf" && Boolean(detail.pdf_url);

          return (
            <section className={styles.releaseDetail}>
              <div className={styles.wrap} style={{ paddingLeft: 0, paddingRight: 0 }}>
                <button type="button" className={styles.backLink} onClick={closeRelease}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  Back to News
                </button>

                {isDetailLoading && <p className={styles.releaseStatus}>Loading full release…</p>}

                {!isDetailLoading && detail && (
                  <>
                    {/* <span className={styles.releaseDate}>{formatReleaseDate(detail.published_at)}</span> */}
                    <h1 className={styles.releaseTitle}>{detail.title}</h1>

                    {hasPdf && (
                      <a href={detail.pdf_url} download={detail.pdf_file_name || undefined} target="_blank" rel="noreferrer" className={styles.downloadLink}>
                        Download PDF
                      </a>
                    )}

                    <div className={styles.releaseFull}>
                      {detail.content_type === "html" && <div dangerouslySetInnerHTML={{ __html: detail.content_html || "" }} />}
                      {detail.content_type === "pdf" && <iframe title={detail.title} src={detail.pdf_url} className={styles.pdfEmbed} />}
                    </div>
                  </>
                )}

                {!isDetailLoading && !detail && <p className={styles.releaseStatus}>Couldn't load this release.</p>}
              </div>
            </section>
          );
        })()}
    </>
  );
};

/* FOOTER COMPONENT */
const Footer = () => {
  const history = useHistory();
  const location = useLocation();

  const navigateToSection = (sectionId) => scrollToSection(history, location, sectionId);

  return (
    <footer className={styles.siteFooter}>
      <div className={styles.wrap} style={{ paddingLeft: 0, paddingRight: 0 }}>
        <div className={styles.footerGrid}>
          <div>
            <div className={styles.footerLogo}>
              Virdio<span>Health</span>
            </div>
            <p className={styles.footerTagline}>AI-powered MSK recovery, built around Myra. Clinically validated outcomes at a cost that transforms the conversation for self-funded employers.</p>
          </div>

          <div>
            <p className={styles.footerColTitle}>Platform</p>
            <div className={styles.footerColLinks}>
              <button type="button" className={styles.footerLink} onClick={() => navigateToSection("myra")}>
                Meet Myra
              </button>
              <button type="button" className={styles.footerLink} onClick={() => navigateToSection("members")}>
                How It Works
              </button>
              <button type="button" className={styles.footerLink} onClick={() => navigateToSection("members")}>
                For Members
              </button>
            </div>
          </div>

          <div>
            <p className={styles.footerColTitle}>Employers/Partners</p>
            <div className={styles.footerColLinks}>
              <button type="button" className={styles.footerLink} onClick={() => navigateToSection("employers")}>
                Comparison
              </button>
              <button type="button" className={styles.footerLink} onClick={() => navigateToSection("results")}>
                ROI Calculator
              </button>
              <button type="button" className={styles.footerLink} onClick={goToMyraIntake}>
                See Myra in Action
              </button>
            </div>
          </div>

          <div>
            <p className={styles.footerColTitle}>Company</p>
            <div className={styles.footerColLinks}>
              <Link to="/about-us" className={styles.footerLink}>
                About Us
              </Link>
              <Link to="/contact-us" className={styles.footerLink}>
                Contact
              </Link>
              <Link to="/news" className={`${styles.footerLink} ${styles.current}`}>
                News
              </Link>
            </div>
          </div>
        </div>

        <div className={styles.footerBottom}>
          <span>© 2026 Virdio Health, Inc. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
};

/* NEWS PAGE */
const NewsPage = () => {
  return (
    <div className={styles.body}>
      <Header />
      <News />
      <Footer />
    </div>
  );
};

export default NewsPage;
